module.exports = __webpack_public_path__ + "img/CB[2]-W-1.14a43929.gif";